import {useState, useEffect} from 'react';
import { H3, Panel, Flex, FlexItem, Button, Text, Box, Modal, Form, FormGroup, Input, Select, Checkbox, Fieldset } from '@bigcommerce/big-design';
import { AddIcon, RemoveCircleOutlineIcon, AddCircleOutlineIcon } from '@bigcommerce/big-design-icons';


export default function FieldForm({ field, isOpen, setIsOpen, handleSave }) {

    const [formValues, setFormValues] = useState({...field});
    const [canSave, setCanSave] = useState(false);

    const handleChanges = (e) => {
        const { name, value } = e.target;
        let tempValues = {...formValues};
        if (name === 'required') {
            tempValues[name] = e.target.checked;
        }
        else if (name === 'checkbox_label') {
            tempValues.config[name] = value;
        }
        else {
            tempValues[name] = value;
        }
        updateFormValues(tempValues);
    };
    
    const handleOptionChanges = (id, value) => {
        const tempFormValues = {...formValues};
        const tempOptions = [...tempFormValues.option_values];
        const index = tempOptions.findIndex(o => o.id === id);
        const tempOption = {...tempOptions[index]};
        tempOption.label = value;
        tempOptions[index] = tempOption;
        tempFormValues.option_values = tempOptions;
        updateFormValues({...tempFormValues});
    };
    
    const handleOptionAction = (action, id) => {
        const tempFormValues = {...formValues};
        const tempOptions = [...tempFormValues.option_values];
        if (action === 'add') {
            tempOptions.push({label: '', id: `option_${Math.random().toString(36).substring(7)}`});
        }
        else if (action === 'delete') {
            const index = tempOptions.findIndex(o => o.id === id);
            const tempOption = {...tempOptions[index]};
            tempOption.deleted = true;
            tempOptions[index] = tempOption;
        }
        tempFormValues.option_values = tempOptions;
        updateFormValues({...tempFormValues});
    };

    const updateFormValues = (fields) => {
        if (fields.name !== '' && fields.label !== '') {
            if (fields.type === 'dropdown' || fields.type === 'radio') {
                if (fields.option_values.length > 0) {
                    setCanSave(true);
                }
                else {
                    setCanSave(false);
                }
            }
            else {
                setCanSave(true);
            }
        }
        else {
            setCanSave(false);
        }
        setFormValues(fields);
    };

    const saveField = () => {
        handleSave(formValues);
    };

    
    return (
        <Modal
            actions={[
            {
                text: 'Cancel',
                variant: 'subtle',
                onClick: () => setIsOpen(false),
            },
            { 
                text: 'Continue', onClick: () => saveField(),
                disabled: !canSave, 
            },
            ]}
            closeOnClickOutside={false}
            closeOnEscKey={true}
            header={`${typeof formValues.id === 'string' && formValues.id.includes('field_') ? 'Add' : 'Edit'} Field`}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            id='field-form'
        >
            <Box id='edit-field' marginBottom={'large'}>
                <FormGroup>
                    <Input
                        label="Display Name"
                        required
                        type="text"
                        name='display_name'
                        value={formValues.display_name}
                        onChange={handleChanges}
                    />
                </FormGroup>
                <FormGroup>
                    <Checkbox
                        label="Required"
                        required
                        name='required'
                        onChange={handleChanges}
                        checked={formValues.required}
                    />
                </FormGroup>
                <FormGroup>
                    <Select
                        label="Type"
                        required
                        options={[
                            { value: 'text', content: 'Text' },
                            { value: 'dropdown', content: 'Dropdown' },
                            { value: 'radio_buttons', content: 'Radio' },
                            { value: 'checkbox', content: 'Checkbox'}
                        ]}
                        onOptionChange={(value) => handleChanges({target: {name: 'type', value}})}
                        value={formValues.type}
                        name='type'
                    />
                </FormGroup>
                {formValues.type === 'checkbox' && 
                    <FormGroup>
                        <Input
                            label="Label"
                            required
                            type="text"
                            name='checkbox_label'
                            value={formValues.checkbox_label}
                            onChange={handleChanges}
                        />
                    </FormGroup>
                }
                {(formValues.type === 'dropdown' || formValues.type === 'radio_buttons') && (
                    <>
                        <Fieldset legend={`Options`}>
                            {formValues.option_values.map((option, index) => {
                                if (!option.deleted) return (
                                    <Flex key={option.id} marginBottom={'small'}>
                                        <FlexItem>
                                            <Input type="text" value={option.label} onChange={(e) => handleOptionChanges(option.id, e.target.value)} />
                                        </FlexItem>
                                        <FlexItem marginLeft={'small'}>
                                            <Button onClick={() => handleOptionAction('delete', option.id)} variant='subtle' iconOnly={<RemoveCircleOutlineIcon title="Remove option" />}></Button>
                                        </FlexItem>
                                    </Flex>
                                );
                            })}
                            <Button onClick={() => handleOptionAction('add')} variant='subtle' iconLeft={<AddIcon />}>Add New Option</Button>
                        </Fieldset>
                    </>
                )}
            </Box>
        </Modal>
    );
}